import {combineReducers} from 'redux'
import {
    LOGIN_SUCCESSFUL,
    LOGOUT,
    ADD_CHAT_MESSAGE,
    SET_CHAT_MESSAGES,
    SET_CARDS,
    SET_CURRENT_PLAYER,
    SET_AVAILABLE_HANDS,
    SET_CURRENT_HAND,
    SET_CARDS_IN_THE_MIDDLE, SET_SCORES, SET_PLAYERS, SET_PREVIOUS_TAKER, SET_PUNISHMENTS, SET_SINGLE_PLAYER,
    SET_AUTH_STATUS, SET_GAME_MODE, SET_DEEPLINK_DATA
} from './actions'

const initialUserState = {
    chatMessages:[],
    isLoggedIn : false,
    username : "",
    cards : [],
    cardsInTheMiddle : [],
    playerId : -1,
    availableHands : [],
    currentHand : "",
    currentPlayer : -1,
    currentPlayerName : "",
    scores : [],
    players : [],
    previousCards : [],
    previousTaker : "",
    room : "",
    punishments : [],
    singlePlayer : false, // Single player mode flag
    // OAuth authentication data
    authProvider : null, // 'google', 'discord', etc.
    authToken : null,
    userProfile : null, // User profile data from OAuth provider
    // New authentication flow states
    isAuthenticated : false, // Whether user completed authentication step
    authType : null, // 'google' or 'guest'
    gameMode : null, // 'single' or 'multiplayer'
    // Deeplink support
    deeplinkRoomId : null,
    deeplinkInviteCode : null,
    isDeeplinkFlow : false
}

function gameState(state = initialUserState, action) {
    switch (action.type) {
        case ADD_CHAT_MESSAGE:
            return {
                ...state,
                chatMessages: [...state.chatMessages, action.message]
            }
        case SET_CHAT_MESSAGES:
            return Object.assign({}, state, {
                chatMessages : action.messages
            })
        case SET_CARDS:
            return Object.assign({}, state, {
                cards : action.text,
                playerId : action.playerId
            })
        case SET_CARDS_IN_THE_MIDDLE:
            return Object.assign({}, state, {
                cardsInTheMiddle : action.text,
            })
        case SET_CURRENT_PLAYER:
            return Object.assign({}, state, {
                currentPlayer : action.text,
                currentPlayerName : action.name
            })
        case SET_CURRENT_HAND:
            return Object.assign({}, state, {
                currentHand : action.text,
            })
        case SET_AVAILABLE_HANDS:
            return Object.assign({}, state, {
                availableHands : action.text,
            })
        case SET_SCORES:
            return Object.assign({}, state, {
                scores : action.text,
            })
        case SET_PLAYERS:
            return Object.assign({}, state, {
                players : action.text,
            })
        case SET_PREVIOUS_TAKER:
            return Object.assign({}, state, {
                previousCards : action.text,
                previousTaker : action.player
            })
        case LOGIN_SUCCESSFUL:
            return Object.assign({}, state, {
                isLoggedIn: true,
                username : action.text,
                room : action.room,
                authProvider : action.authProvider || null,
                authToken : action.authToken || null,
                userProfile : action.userProfile || null,
                // Preserve existing authType and gameMode if not provided in action
                authType: action.authType || state.authType,
                gameMode: action.gameMode || state.gameMode,
                isAuthenticated: action.isAuthenticated !== undefined ? action.isAuthenticated : state.isAuthenticated
            })
        case SET_PUNISHMENTS:
            return Object.assign({}, state, {
                punishments : action.text
            })
        case SET_SINGLE_PLAYER:
            return Object.assign({}, state, {
                singlePlayer : action.singlePlayer
            })
        case SET_AUTH_STATUS:
            return Object.assign({}, state, {
                isAuthenticated : action.isAuthenticated,
                authType : action.authType
            })
        case SET_GAME_MODE:
            return Object.assign({}, state, {
                gameMode : action.gameMode
            })
        case SET_DEEPLINK_DATA:
            return Object.assign({}, state, {
                deeplinkRoomId : action.roomId,
                deeplinkInviteCode : action.inviteCode,
                isDeeplinkFlow : !!(action.roomId || action.inviteCode)
            })
        case LOGOUT:
            return initialUserState
        default:
            return state
    }
}

const kingGame = combineReducers({
    gameState
})

export default kingGame